// Canonical labels — one source of truth
export const ORDER_STATUS_LABELS = {
  pending: 'Ожидает оплаты',
  reserved: 'Резерв',
  paid: 'Оплачен',
  preparing: 'Собирается',
  ready: 'Готов к выдаче',
  delivered: 'Выдан',
  cancelled: 'Отменён',
};

export const ORDER_STATUS_FLOW = ['pending', 'paid', 'preparing', 'ready', 'delivered'];
export const ACTIVE_STATUSES = ['pending', 'reserved', 'paid', 'preparing', 'ready'];
